import * as ol from 'openlayers';
import BaseLineAspect from './BaseLineAspect';

export default class BaseEnlightLineAspect extends BaseLineAspect {

  constructor(data) {
    super(data);
  }

  showMouseOver() {
    let styles = this.getStyle();
    // if (this.get('line') != undefined) {
    if (styles != undefined) {
      let line = this.get('geometry');

      let origColor = this.getBaseColor();
      if(origColor == '000000'){
        origColor = '#666666';
      }
      let gByte = parseInt(origColor.substring(3,5), 16);
      let diff = 255 - gByte
      let boldColr = origColor.substring(0,3) + diff.toString(16) + origColor.substring(5,7);
        if (origColor !== '#009933') {
        if (origColor == '#ffff00') {
          boldColr = '#ee0000';
        } else if (origColor == '#ff8000') {
          boldColr = '#a5fb2b';
        } else {
          boldColr = '#990000';
        }
      }
      let strokeStyle = new ol.style.Stroke({
        color: boldColr,
        width: 5,
      });
      let lineStyle = new ol.style.Style({
        geometry: line,
        stroke: strokeStyle,
      });

      styles[0] = lineStyle;
      this.setStyle(styles);
    }
  }

  hideMouseOver() {
    let styles = this.getStyle();
    if (styles != undefined) {
      this.setStyle(this.createStyle());
    }
  }
}
